function mhProducts(){
    var quantity = '<span class="quantity">'
    quantity += '<span class="increase-tooltip js-increase-tooltip" data-trigger="manual" data-container="body" data-original-title="Není možné zakoupit více než 9999 ks." aria-hidden="true" role="tooltip" data-testid="tooltip"></span>'
    quantity += '<span class="decrease-tooltip js-decrease-tooltip" data-trigger="manual" data-container="body" data-original-title="Minimální množství, které lze zakoupit, je 1 ks." aria-hidden="true" role="tooltip" data-testid="tooltip" aria-describedby="tooltip634711"></span>'
    quantity += '<label><input type="number" name="amount" value="1" class="amount" autocomplete="off" data-decimals="0" step="1" min="1" max="9999" aria-label="Množství" data-testid="cartAmount" data-gtm-form-interact-field-id="0"></label>'
    quantity += '<button class="increase" type="button" aria-label="Zvýšit množství o 1" data-testid="increase"><span class="increase__sign">+</span></button>'
    quantity += '<button class="decrease" type="button" aria-label="Snížit množství o 1" data-testid="decrease"><span class="decrease__sign">−</span></button>'
    quantity += '</span>'
    if($('.products:not(#productsTop)').length){
        $('.product').each(function(){

            const $product = $(this);
                //const productId = $product.find('span[data-micro="sku"]').text().trim();
                if($(this).hasClass('lb-product')){
                    var productId = $(this).find('div[data-micro="product"]').attr('data-micro-product-id').trim();
                }
                else{
                    var productId = $(this).find('span[data-micro="sku"]').text().trim();
                }
                if (productId) {
                    $product.find('.p').append(`
                        <div class="customFavorite">
                            <span class="add-to-favorites" data-id="${productId}" data-ids='["${productId}"]'>
                                Přidat do oblíbených
                            </span>
                        </div>
                    `);
                }


            if($(this).find('.price-standard').length){
                if(!$(this).find('.prices .price-standard').length){
                    $(this).find('.prices').prepend($(this).find('.price-standard'))
                }
            }
            if($(this).find('.add-to-cart-button').length){
                if(!$(this).find('.quantity').length){
                    $(this).find('.add-to-cart-button').before(quantity)

                }
            }
            if($(this).find('.flag-discount').length){
                $(this).find('.flag-discount').html($(this).find('.flag-discount').html().replace("až", ""));
            }
            if($(this).find('.price.price-final small').length){
                $(this).find('.p-tools a.btn.btn-primary').text('Varianty')
            }
        })
    }

}


$(document).ready(function() {
    mhProducts()
  })
document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    mhProducts()
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    mhReplace();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    mhProducts();
});